// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const KOREA_PHARMA_FIELD_ALIASES = {
  hospitalName: ['병원명'],
  drugCode: ['제품코드'],
  drugName: ['제품명'],
  unitPrice: ['가격'],
  quantity: ['수량'],
  prescriptionAmount: ['처방합계'],
  feeRate: ['최종수수료'],
  settlementAmount: ['수수료금액'],
  pharmaceuticalCompanyName: ['제약사'],
  approvalStatus: ['처방승인'],
  noteReason: ['비고2'],
};

const REQUIRED_HEADERS = [
  '처방월',
  '병원코드',
  '담당자명',
  '병원명',
  '제품명',
  '제품코드',
  '제약사',
  '수량',
  '가격',
  '처방합계',
  '최종수수료',
  '수수료금액',
  '처방승인',
  '비고1',
  '비고2',
];

function isKoreaPharmaProfile(profile) {
  return REQUIRED_HEADERS.every((header) =>
    profile.headers.some(
      (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
    ),
  );
}

const koreaPharmaTemplate = {
  id: 'korea-pharma',
  name: '한국파마 템플릿',
  match(context) {
    return context.headerProfiles.some(isKoreaPharmaProfile);
  },
  extract(context) {
    const targetProfiles = context.headerProfiles.filter(isKoreaPharmaProfile);
    if (targetProfiles.length === 0) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const extractedRows = [];

    targetProfiles.forEach((profile) => {
      const sheetName = profile.sheetName;
      const rows = context.sheetRowsMap[sheetName] || [];
      const headerRow = rows[profile.headerRowIndex] || [];
      const columnMap = buildColumnMap(
        headerRow,
        buildNormalizedAliases(KOREA_PHARMA_FIELD_ALIASES),
      );

      rows.slice(profile.headerRowIndex + 1).forEach((row, rowOffset) => {
        if (
          !Array.isArray(row) ||
          row.every((cell) => cleanText(cell) === '')
        ) {
          return;
        }

        const productCode = cleanText(row[columnMap.drugCode]);
        if (!productCode) {
          return;
        }

        const approvalStatus = cleanText(row[columnMap.approvalStatus]);
        const note =
          approvalStatus && approvalStatus !== '승인'
            ? cleanText(row[columnMap.noteReason])
            : '';

        const record = buildStandardRecord({
          fileName: context.file.name,
          sheetName,
          rowIndex: profile.headerRowIndex + rowOffset + 1,
          templateId: this.id,
          detectedPharmaceuticalCompany: cleanText(
            row[columnMap.pharmaceuticalCompanyName],
          ),
          customerName: row[columnMap.hospitalName],
          drugCode: row[columnMap.drugCode],
          drugName: row[columnMap.drugName],
          unitPriceValue: row[columnMap.unitPrice],
          quantityValue: row[columnMap.quantity],
          prescriptionAmountValue: row[columnMap.prescriptionAmount],
          feeRateValue: row[columnMap.feeRate],
          settlementAmountValue: row[columnMap.settlementAmount],
          note,
        });

        if (shouldSkipRecord(record, row)) {
          return;
        }

        extractedRows.push(record);
      });
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: '한국파마',
      templateName: this.name,
    };
  },
};

export default koreaPharmaTemplate;
